import React from "react";
import heroImage from "assests/About/1.jpg";
import Container from "Components/Container/Container";
import SocialMedia from "Pages/Home/Hero/SocialMedia/SocialMedia";

const Hero = ({ data }) => {
  return (
    <section className="scroll-section h-[100vh] relative">
      <img
        className="absolute w-[100vw] left-0 top-0 h-[100vh] object-cover z-[0]"
        src={heroImage}
        alt=""
      />
      <Container className={`relative z-[10] h-full flex justify-between `}>
        <div className="h-full  flex-1 flex flex-col justify-center items-center">
          {/* <p className="text-3xl text-white mb-4 uppercase  text-gray-400">
            {data.title}
          </p> */}
          <h1 className="text-5xl lg:text-7xl text-white text-center bebas capitalize mb-[6rem]">
            {data?.sub_title}
          </h1>
        </div>
        <SocialMedia />
      </Container>
    </section>
  );
};

export default Hero;
